import * as S from './Styled';
import { steps } from '../../../../constants/HomeCupom/steps'
import { Accordion, AccordionSummary, AccordionDetails, Typography, Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { faqSections } from '../../../../constants/HomeCupom/faqsections';

const ComoUtilizarUmCupom = ({ onOpenLogin }) => {
    const sections = faqSections(onOpenLogin);
    return (
        <S.ContainerCupom>
            <S.Header>
                <S.TitleCupom>COMO USAR UM CUPOM</S.TitleCupom>
                <S.Description>
                É bem fácil usar um cupom de desconto através do Meu Cupom e nós vamos te explicar!
                </S.Description>
            </S.Header>

            <S.StepsWrapper>
                {steps.map((etapa) => (
                <S.Step key={etapa.id}>
                    <S.Image src={etapa.imagem} alt={`Etapa ${etapa.id}`} />
                </S.Step>
                ))}
            </S.StepsWrapper>
            {sections.map((section, i) => (
                <Accordion
                key={i}
                sx={{
                    width: '100%',
                    maxWidth: { xs: '80%', md: '800px' },
                    mx: 'auto',
                    boxShadow: 3,
                    mb: 2,
                    overflow: 'hidden',
                    '&:before': { display: 'none' },
                        borderRadius: '16px !important',
                    '&.Mui-expanded': {
                        borderRadius: '16px !important',
                        mb: 2,
                    },
                }}
                >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    sx={{
                    borderRadius: '16px',
                    '&.Mui-expanded': {
                        borderRadius: '16px 16px 0 0',
                        borderBottom: '1px solid #e0e0e0',
                    },
                    }}
                >
                    <Typography
                    sx={{ color: '#1B1464', fontWeight: 'bold', fontSize: '1.1rem' }}
                    >
                    {section.sectionTitle}
                    </Typography>
                </AccordionSummary>

                <AccordionDetails sx={{ backgroundColor: '#fff' }}>
                    {section.steps.map((step, j) => (
                    <Box key={j} sx={{ mb: 3 }}>
                        <Typography
                        variant="subtitle2"
                        sx={{
                            fontWeight: 600,
                            color: '#1B1464',
                            mb: 1,
                        }}
                        >
                        {step.title}
                        </Typography>
                        <Box
                        sx={{
                            backgroundColor: '#FFF1A8',
                            borderRadius: '50px',
                            px: 3,
                            py: 2,
                            maxWidth: '100%',
                        }}
                        >
                        <Typography sx={{ color: '#333' }}>
                            {step.description}
                        </Typography>
                        </Box>
                    </Box>
                    ))}
                </AccordionDetails>
                </Accordion>
            ))}
        </S.ContainerCupom>
        
    )
}

export default ComoUtilizarUmCupom;